<div class="flex flex-col gap-10">
  @if (router.url.includes('/add')) {
    <h1>Dodawanie członka rodziny</h1>
  } @else {
    <h1>Edycja danych członka rodziny</h1>
  }
  <app-info-message [labelHTML]="'ustawienia.informacje.polaWymagane'">
  </app-info-message>
  <p-card header="Dane osobowe" class="custom-card">
    <app-form-beneficiary-details
      [readonlyControls]="[]"
      [formGroup]="formGroup().controls.details"
      [familyMember]="true"
    ></app-form-beneficiary-details>
  </p-card>
  <p-card header="Adres zamieszkania" class="custom-card">
    <app-form-address
      [formGroup]="formGroup().controls.address"
    ></app-form-address>
  </p-card>
  <p-card
    header="Nazwa i adres szkoły, do której uczęszcza"
    class="custom-card"
  >
    <app-form-family-member-school
      [formGroup]="formGroup().controls.school"
      [daneOsobowe]="formGroup().controls.details"
    ></app-form-family-member-school>
  </p-card>
</div>
<div class="flex justify-end mt-4 gap-4">
  <p-button
    styleClass="customInfoButton outlined"
    label="Anuluj"
    (click)="navigateToFamilyMembers()"
  ></p-button>
  <p-button
    styleClass="customInfoButton"
    label="Zapisz"
    (click)="save()"
  ></p-button>
</div>
